export const members = [
 {
   "LName": "Jones",
   "DistrictNum": "1",
   "DISTRICT": "District 1",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Charles Jones",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "Rules and Open Government Committee, Member; Public Safety, Finance, and Strategic Support Committee, Vice Chair; Smart Cities and Service Improvements Committee, Chair; Board of Fair Campaign & Political Practices, Liaison; Work2future Board, Council Liaison; Santa Clara Valley Transportation Authority Board of Directors, Member; Capital Projects Oversight Committee; Safety, Security, and Transit Planning and Operations Committee; Santa Clara VTA Policy Advisory Board – El Camino Real Rapid Transit, Alternate; Santa Clara County Cities Association Board, Member; City Selection Committee, Member; Legislative Action Committee, Member; Silicon Valley Regional Interoperability Project, Member; San Jose/Santa Clara Clean Water Financing Authority, Member; West Valley Sanitation District – Sewer Advisory Board, Member; Santa Clara Valley Habitat Agency Implementation Board, VTA Representative Alternate",
   "INCUMBENT": "Y",
   "WEB": "https://www.sjdistrict1.com",
   "EMAIL": "mailto:District1@sanjoseca.gov",
   "PHONE": "408.535.4901",
   "City_News": "https://www.sjdistrict1.com/district-1-newsletter/",
   "Blog": "https://www.sjdistrict1.com/news-and-press/",
   "TWITTER": "https://www.twitter.com/chappiejones",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "David Gomez",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:david.gomez@sanjoseca.gov",
   "CONFLICTS": 35,
   "DONORS": 156,
   "PERSONAL_EMAIL": "mailto:chappiejones@yahoo.com",
   "Vote_Y": "91%",
   "Vote_N": "6%",
   "Vote_A": "3%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D1_Chappie-Jones.jpg"
 },
 {
   "LName": "Jimenez",
   "DistrictNum": "2",
   "DISTRICT": "District 2",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Sergio Jimenez",
   "Term_YRS": 4,
   "Term_Start": "11/1/16",
   "Term_End": "12/31/20",
   "TERM REMAINING": 492,
   "COMMITTEES": "City’s Transportation and Environment Committee, Public Safety Committee and Neighborhood Services Committee, Local Agency Formation Commission (LAFCO) and Association of Bay Area Governments (ABAG)",
   "INCUMBENT": "N",
   "WEB": "https://www.sanjoseca.gov/district2",
   "EMAIL": "mailto:District2@sanjoseca.gov",
   "PHONE": "408.535.4902",
   "City_News": "https://www.sanjoseca.gov/index.aspx?NID=5389",
   "Blog": "https://www.sanjoseca.gov/index.aspx?NID=5610",
   "TWITTER": "https://www.twitter.com/D2SergioJimenez ",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Vanessa Sandoval",
   "Liaison _HONE": "408.535.4925",
   "LIASON_EMAIL": "mailto:Vanessa.Sandoval@sanjoseca.gov",
   "CONFLICTS": 6,
   "DONORS": 40,
   "PERSONAL_EMAIL": "mailto:pattyejimenez@yahoo.com",
   "Vote_Y": "78%",
   "Vote_N": "14%",
   "Vote_A": "8%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D2-Sergio-Jimenez.jpg"
 },
 {
   "LName": "Peralez",
   "DistrictNum": "3",
   "DISTRICT": "District 3",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Raul Peralez",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "Public Safety; Finance; & Strategic Services Committee (Chair); Transportation & Environment Committee; Community & Economic Development Committee; Ad-Hoc Committee for Construction & Development Services; Association of Bay Area Governments (ABAG) Executive Board; ABAG Administrative Committee; Airport Commission (Liaison); Capitol Corridor Joint Powers Authority; Downtown Parking Board (Liaison); Hammer Theater Advisory Committee; League of California Cities – Latino Caucus; Mayor’s Gang Prevention Task Force; Team San Jose Board (Liaison); Santa Clara County Reentry Network; Santa Clara Valley Transportation Authority Board (VTA); VTA Policy Advisory Board – Diridon Station (Chair); VTA Congestion Management Program and Planning (Chair); VTA Governance & Audit Committee",
   "INCUMBENT": "Y",
   "WEB": "sjd3.com",
   "EMAIL": "mailto:District3@sanjoseca.gov",
   "PHONE": "408.535.4903",
   "City_News": "sjd3.com/by-date/",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/D3SanJose",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Christina Ramos",
   "Liaison _HONE": "408.535.4934",
   "LIASON_EMAIL": "mailto:christina.m.ramos@sanjoseca.gov",
   "CONFLICTS": 11,
   "DONORS": 350,
   "PERSONAL_EMAIL": "mailto:raul@raulperalez.com",
   "Vote_Y": "95%",
   "Vote_N": "4%",
   "Vote_A": "1%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D3-Raul-Peralez.jpg"
 },
 {
   "LName": "Diep",
   "DistrictNum": "4",
   "DISTRICT": "District 4",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Lan Diep",
   "Term_YRS": 4,
   "Term_Start": "11/1/16",
   "Term_End": "12/31/20",
   "TERM REMAINING": 492,
   "COMMITTEES": "",
   "INCUMBENT": "N",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=152",
   "EMAIL": "mailto:District4@sanjoseca.gov",
   "PHONE": "408.535.4904",
   "City_News": "https://www.sanjoseca.gov/index.aspx?nid=3304",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/SanJoseD4 ",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Chris Rork",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:Christopher.Rork@sanjoseca.gov",
   "CONFLICTS": 15,
   "DONORS": 21,
   "PERSONAL_EMAIL": "mailto:lan@lanforsanjose.com",
   "Vote_Y": "83%",
   "Vote_N": "10%",
   "Vote_A": "7%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D4-Lan-Diep.jpg"
 },
 {
   "LName": "Carrasco",
   "DistrictNum": "5",
   "DISTRICT": "District 5",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Magdalena Carrasco",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "Ad-Hoc Housing Construction and Development Committee, Chair; Neighborhood Services and Education, Vice Chair; Public Safety, Finance & Strategic Support, Member; Valley Transportation Authority, Board Member; Sister Cities International Board of Directors, Member; Valley Transportation Authority, CMPP, Member; Valley Transportation Authority, Downtown/ East Valley Policy Advisory Committee, Member; Human Services Commission, Liaison",
   "INCUMBENT": "Y",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=150",
   "EMAIL": "mailto:District5@sanjoseca.gov",
   "PHONE": "408.535.4905",
   "City_News": "https://www.sanjoseca.gov/index.aspx?NID=4660",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/CM_Magdalena",
   "Facebook": "https://www.facebook.com/VM.MagdalenaCarrasco",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "https://www.instagram.com/cm_magdalena/",
   "Liaison": "Frances Herbert",
   "Liaison _HONE": "408.535.4948",
   "LIASON_EMAIL": "mailto:frances.herbert@sanjoseca.gov",
   "CONFLICTS": 5,
   "DONORS": 467,
   "PERSONAL_EMAIL": "mailto:voteformagdelena@gmail.com",
   "Vote_Y": "92%",
   "Vote_N": "6%",
   "Vote_A": "2%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D5-Magdalena-Carassco.jpg"
 },
 {
   "LName": "Davis",
   "DistrictNum": "6",
   "DISTRICT": "District 6",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Devora “Dev” Davis",
   "Term_YRS": 4,
   "Term_Start": "11/1/16",
   "Term_End": "12/31/20",
   "TERM REMAINING": 492,
   "COMMITTEES": "Chair of the Transportation & Environment Committee; Member of the Rules Committee; Member of AD-HOC Committee for Housing Construction & Development Services; Member of the Smart Cities & Innovation Committee; Member of the San Jose/Santa Clara Treatment Plant Advisory Committee (TPAC); Council Liaison to the Federated Retirement Board Council Liaison to the Historic Landmarks Commission; Council Liaison to the Santa Clara County Emergency Operational Area Council (formerly Emergency Preparedness Council); Caltrain San Jose Representative on Joint Powers Board (JPB); Caltrain San Jose Representative on Local Policy Maker Group (LPMG); Caltrain Member of the Ad-Hoc Committee on Positive Train Control/Communications - Based Overlay Signal System (PTC/CBOSS); Caltrain Member of the Centralized Equipment Maintenance & Operations Facilities Oversight Committee (CEMOF); VTA Alternate Member for the Board; VTA Member of the Diridon Station Joint Policy Advisory Board; VTA Member of the El Camino Real Grand Boulevard Initiative; VTA Alternate Member for Safety, Security, and Transit Planning and Operations (SSTPO); San Jose Sports Authority Board of Directors – City Council Liaison; San Jose Arena Authority Board of Directors – City Council Liaison; Grand Boulevard Initiative Task Force – City Council Liaison; SJ/SC Treatment Plant Advisory Committee - City Council Liaison",
   "INCUMBENT": "N",
   "WEB": "https://www.sjd6.org/",
   "EMAIL": "mailto:district6@sanjoseca.gov",
   "PHONE": "408.535.4906",
   "City_News": "sjd6.org/newsletter/",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/DevDavisCA",
   "Facebook": "https://www.facebook.com/devdavisCA/",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "https://www.instagram.com/devdavisca/",
   "Liaison": "Mary Anne Groen",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:maryanne.groen@sanjoseca.gov",
   "CONFLICTS": 5,
   "DONORS": null,
   "PERSONAL_EMAIL": "",
   "Vote_Y": "89%",
   "Vote_N": "5%",
   "Vote_A": "6%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D6-Dev-Davis.jpg"
 },
 {
   "LName": "Esparza",
   "DistrictNum": "7",
   "DISTRICT": "District 7",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Maya Esparza",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "",
   "INCUMBENT": "N",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=154",
   "EMAIL": "mailto:District7@sanjoseca.gov",
   "PHONE": "408.535.4907",
   "City_News": "",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/MayaEsparza3 ",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Andrés Quintero",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:Andres.Quintero@sanjoseca.gov",
   "CONFLICTS": 2,
   "DONORS": 659,
   "PERSONAL_EMAIL": "mailto:info@mayaesparza.com",
   "Vote_Y": "92%",
   "Vote_N": "2%",
   "Vote_A": "6%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D7-Esparza-Maya.png"
 },
 {
   "LName": "Arenas",
   "DistrictNum": "8",
   "DISTRICT": "District 8",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Sylvia Arenas",
   "Term_YRS": 4,
   "Term_Start": "11/1/16",
   "Term_End": "12/31/20",
   "TERM REMAINING": 492,
   "COMMITTEES": "Neighborhood Services & Education Committee – Vice Chair; Transportation & Environment Committee – Member; Ad-Hoc Committee for Development Services – Member; Habitat Conservation Agency Governing Board – Board Member; Habitat Conservation Agency Implementation Board – Member; VTA Downtown/East Valley Policy Advisory Board – Member; Appeals Hearing Board – Liaison; Schools City Collaborative – Member; SJ/SC Treatment Plant Advisory (TPAC) Committee – Alternate; Recycled Water Policy Advisory Committee – Member; Santa Clara County Local Agency Formation (LAFCO)  – Alternate",
   "INCUMBENT": "N",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=156",
   "EMAIL": "mailto:district8@sanjoseca.gov",
   "PHONE": "408.535.4908",
   "City_News": "",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/SylviaArenas ",
   "Facebook": "https://www.facebook.com/councilwomansylviaarenas",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Patrick McGarrity",
   "Liaison _HONE": "408-535.4969",
   "LIASON_EMAIL": "mailto:patrick.mcgarrity@sanjoseca.gov",
   "CONFLICTS": 0,
   "DONORS": 17,
   "PERSONAL_EMAIL": "mailto:arenasldf@deaneandcompany.com",
   "Vote_Y": "82%",
   "Vote_N": "3%",
   "Vote_A": "15%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D8-Sylvia-Arenas.jpg"
 },
 {
   "LName": "Foley",
   "DistrictNum": "9",
   "DISTRICT": "District 9",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Pam Foley",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "San José Learns Task Force; Ad-Hoc Committee for Development Services (Member); Community & Economic Development Committee (Member); Neighborhood Services & Education Committee (Member); Association of Bay Area Governments -ABAG (Alternate); Appeals Hearing Board (Liaison); Citizen Corps Council (Vice Chair); Emergency Preparedness Council; Police & Fire Retirement Board (Non-Voting Member); Recycling & Waste Reduction Commission of Santa Clara County; Santa Clara Valley Habitat Agency Governing Board; Santa Clara Valley Habitat Agency Implementation Board (Alternate); Santa Clara Valley Water District - Water Commission (2-year Appointment); Silicon Valley Interoperability Project",
   "INCUMBENT": "N",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=155",
   "EMAIL": "mailto:District9@sanjoseca.gov",
   "PHONE": "408.535.4909",
   "City_News": "",
   "Blog": "",
   "TWITTER": "https://www.twitter.com/PamFoleyD9 ",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Scott Hughes",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:scott.hughes@sanjoseca.gov",
   "CONFLICTS": 6,
   "DONORS": 631,
   "PERSONAL_EMAIL": "mailto:pam@foleymg.com",
   "Vote_Y": "89%",
   "Vote_N": "6%",
   "Vote_A": "5%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D9-Foley_Pam.jpg"
 },
 {
   "LName": "Khamis",
   "DistrictNum": "10",
   "DISTRICT": "District 10",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Johnny Khamis",
   "Term_YRS": 4,
   "Term_Start": "11/1/16",
   "Term_End": "12/31/20",
   "TERM REMAINING": 492,
   "COMMITTEES": "Rules Committee; Public Safety, Finance, & Strategic Support Committee; Community & Economic Development - Chairperson; Federated Employees Retirement Board - Non-Voting; Santa Clara County Local Agency Formation; Santa Clara Valley Transportation Authority Board; Santa Clara Valley Transportation Governance and Audit Committee; Santa Clara Valley Transportation Transit Planning and Operations Committee - Chairperson; Strategic Planning Advisory Board; Civil Service Commission; Deferred Compensation Advisory Committee; Parks & Recreation Commission; Senior Citizens Commission",
   "INCUMBENT": "Y",
   "WEB": "https://www.sjd10.com",
   "EMAIL": "mailto:District10@sanjoseca.gov",
   "PHONE": "408.535.4910",
   "City_News": "https://www.sjd10.com/d10-accomplishments.html",
   "Blog": "https://www.sjd10.com/newsletter-archives.html",
   "TWITTER": "https://www.twitter.com/JohnnyKhamis",
   "Facebook": "",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "",
   "Liaison": "Shane Patrick Connolly",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:shane.connolly@sanjoseca.gov",
   "CONFLICTS": 20,
   "DONORS": null,
   "PERSONAL_EMAIL": "",
   "Vote_Y": "87%",
   "Vote_N": "3%",
   "Vote_A": "10%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/D10-Khamis-John.png"
 },
 {
   "LName": "Liccardo",
   "DistrictNum": "City",
   "DISTRICT": "Mayor",
   "Source": "https://www.sanjoseca.gov/index.aspx?NID=146",
   "CName": "Sam Liccardo",
   "Term_YRS": 4,
   "Term_Start": "11/1/18",
   "Term_End": "12/31/22",
   "TERM REMAINING": 1222,
   "COMMITTEES": "",
   "INCUMBENT": "Y",
   "WEB": "https://www.sanjoseca.gov/index.aspx?NID=203",
   "EMAIL": "mailto:mayoremail@sanjoseca.gov",
   "PHONE": "408.535.4800 ",
   "City_News": "https://www.sanjoseca.gov/index.aspx?nid=661",
   "Blog": "https://www.sanjoseca.gov/index.aspx?NID=5262",
   "TWITTER": "https://www.twitter.com/sliccardo ",
   "Facebook": "https://www.facebook.com/SamLiccardo1/",
   "Nextdoor": "https://www.nextdoor.com/agency-detail/ca/san-jose/san-jose-city-council/?i=gxssvwxjhatybvdjprrk",
   "Instagram": "https://www.instagram.com/samliccardo/?ref=badge",
   "Liaison": "Jim Reed",
   "Liaison _HONE": "",
   "LIASON_EMAIL": "mailto:jim.reed@sanjoseca.gov",
   "CONFLICTS": 89,
   "DONORS": 2348,
   "PERSONAL_EMAIL": "",
   "Vote_Y": "96%",
   "Vote_N": "2%",
   "Vote_A": "2%",
   "Photo": "//d3ju1gh2kf3yfd.cloudfront.net/entite/Mayor-Sam-Liccardo.jpg"
 }
]